import TextField from '@mui/material/TextField';
import DateRangePicker from 'components/DatePickers/DateRangePicker';
import React from 'react';
const styles = require('./styles.pcss');

interface Filter {
  name: string;
  label: string;
  type: string;
  options?: string[];
  config?: { [key: string]: any };
}

interface FilterComponentProps {
  filters: Filter[];
  onFilterChange: (filterValues: Record<string, string>) => void;
}

const FilterComponent: React.FC<FilterComponentProps> = ({ filters, onFilterChange }) => {
  const handleFilterChange = (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>, filterName: string) => {
    const { value } = event.target;
    onFilterChange({ [filterName]: value });
  };

  return (
    <div className={styles.filtersContainer}>
      {filters.map((filter) => (
      <div key={filter.name} className={styles.filterControl}>
        {filter.type === 'search' && (
        <TextField
          variant="outlined"
          label={filter.label}
          className={styles.filterInput}
          onChange={(event) => handleFilterChange(event, filter.name)}
        />
        )}
        {filter.type === 'select' && (
        <select className={styles.filterSelect} onChange={(event) => handleFilterChange(event, filter.name)}>
          {filter.options && filter.options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
          ))}
        </select>
        )}
        {filter.type === 'date' && filter.config && (
          <DateRangePicker
            startDate={filter.config.startDate}
            endDate={filter.config.endDate}
            error={filter.config.error}
            label={filter.label}
            className={[styles.input, styles.dates]}
            onChange={(values: any) => onFilterChange(values)}
            bottomText=""
            bottomTextColor="#FC3B60"
            autoCloseOnSelect={true}
          />
        )}
      </div>
      ))}
    </div>
  );
};

export default FilterComponent;
